import {Grid} from '@mui/material';

import styles from 'assets/css/wizard.module.css';
import Header from './Header';
import DotStepper from './DotStepper';

const Wizard = (props) => {
  const {
    stepLength,
    children,
    titleText,
    inParenthesesText,
    activeStep,
    backStepHandler,
  } = props;

  return (
    <Grid container className={styles.wrapper}>
      <Header
        title={titleText}
        activeStep={activeStep}
        inParentheses={inParenthesesText}
        backStepHandler={backStepHandler}
      />
      <Grid item xs={12}>
        {children}
      </Grid>
      <DotStepper stepLength={stepLength} activeStep={activeStep} />
    </Grid>
  );
};

export default Wizard;
